import apiClient from '@/services/axios'

/**
 * Fetch effective permissions (baseline + overrides) for a user.
 * Self-read is always allowed; reading others requires permission_overrides.view.
 * @param {number|string} userId
 * @returns {Promise<{ resource: string, tier: 'view'|'operate'|'extract'|null, source: 'baseline'|'override' }[]>}
 */
export function getEffectivePermissions(userId) {
  return apiClient.get(`/permissions/effective/${userId}`).then((res) => res.data)
}

/**
 * List all roles ordered by hierarchy DESC.
 * Used by role-assignment dropdowns.
 */
export function getRoles() {
  return apiClient.get('/permissions/roles').then((res) => res.data)
}

/**
 * Per-user permission overrides.
 */
export function getOverrides(userId) {
  return apiClient.get(`/permissions/overrides/${userId}`).then((res) => res.data)
}

export function setOverride(userId, resource, tier) {
  return apiClient.put(`/permissions/overrides/${userId}`, { resource, tier }).then((res) => res.data)
}

export function removeOverride(userId, resource) {
  return apiClient.delete(`/permissions/overrides/${userId}/${resource}`).then((res) => res.data)
}

/**
 * Update a role's actions and/or PII visibility.
 * @param {number} roleId
 * @param {{ role?: string, actions?: object, piiVisibility?: object }} updates
 */
export function updateRole(roleId, updates) {
  return apiClient.patch(`/permissions/roles/${roleId}`, updates).then((res) => res.data)
}

/**
 * Fetch UI metadata for the permission grid:
 *  - resources: [{ key, label, category, hasPii }]
 *  - actions: ['view', 'add', 'edit', 'delete', 'export']
 * Single source of truth — keeps frontend in sync with backend Resource enum.
 */
export function getPermissionMeta() {
  return apiClient.get('/permissions/meta').then((res) => res.data)
}
